import type { IUserProfileClaim } from '@gik/calendar/models/Claim';
import bemBlock from '@gik/core/utils/bemBlock';
import { ClaimedItemCard } from '@gik/user-profile/components/ClaimedItemCard/ClaimedItemCard';
import moment from 'moment/moment';
import React from 'react';

export interface IClaimedItemsListProps {
  items: IUserProfileClaim[];
  className?: string;
}

const blockName = 'claimed-items-list';

export default function ClaimedItemsList({ items, className }: IClaimedItemsListProps) {
  const bem = bemBlock(blockName);

  return (
    <ul className={bem(null, null, className)}>
      {items
        ?.sort((a, b) => moment.utc(b.entry.startsAt).diff(moment.utc(a.entry.startsAt)))
        .map(claimedItem => (
          <li className="claimed-items-list-item" key={claimedItem.id}>
            <ClaimedItemCard claimedItem={claimedItem} />
          </li>
        ))}
    </ul>
  );
}
